module.exports = __webpack_public_path__ + "static/media/disclaimersImage.fc3f9b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/disclaimersImage.png
// module id = 1001
// module chunks = 0